var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNswOutlined = function SvgNswOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3 13.116V5.377l10.987.227.79-.432 2.093.205.424.7 1.235-.905L19.642 5H21l-.523.98-.835 2.921-.76 2.022-1.588 1.616-1.059.878v1.275l-.662 1.441-.796 1.617V19l-1.718-.538L12 16.846l-2.922-.713H7.765l-3.177-2.518z"
  })));
};
export default SvgNswOutlined;